/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';
import { applyQuestionLinkMetadata, groupMediaQuestions } from './helpers';

const transformSurveyQuestions = surveyQuestions => {
  // Apply transformations on questions
  let questions = surveyQuestions;
  questions = questions.map(q => applyQuestionLinkMetadata(q)) || [];
  questions = groupMediaQuestions(questions);
  return questions;
};

export default {
  // SURVEY
  [types.LIST_SURVEYS_REQUEST]: state => {
    state.surveyListLoading = true;
    state.surveyListSuccess = false;
    state.surveyListError = null;
  },
  [types.LIST_SURVEYS_SUCCESS]: (state, { surveys, pageNumber, totalPages }) => {
    state.surveyListLoading = false;
    state.surveyListSuccess = true;
    state.surveyList = surveys;
    state.surveyListPage = pageNumber;
    state.surveyListTotalPages = totalPages;
  },
  [types.LIST_SURVEYS_FAILURE]: (state, payload) => {
    state.surveyListLoading = false;
    state.surveyListSuccess = false;
    state.surveyListError = payload;
  },

  [types.GET_SURVEY_REQUEST]: state => {
    state.surveyLoading = true;
    state.surveyLoadSuccess = false;
    state.surveyLoadError = null;
  },
  [types.GET_SURVEY_SUCCESS]: (state, payload) => {
    state.surveyLoading = false;
    state.surveyLoadSuccess = true;
    state.survey = payload;

    state.canvasQuestions = transformSurveyQuestions(state.survey.questions);
  },
  [types.GET_SURVEY_FAILURE]: (state, payload) => {
    state.surveyLoading = false;
    state.surveyLoadSuccess = false;
    state.surveyLoadError = payload;
  },

  // QUESTIONS
  [types.GET_QUESTIONS_REQUEST]: state => {
    state.questionsLoading = true;
    state.questionsLoadSuccess = false;
    state.questionsLoadError = null;
  },
  [types.GET_QUESTIONS_SUCCESS]: (state, payload) => {
    state.questionsLoading = false;
    state.questionsLoadSuccess = true;
    state.questionList = payload.entries;
    state.questionsPage = payload.pageNumber;
    state.questionsTotalPages = payload.totalPages;
  },
  [types.GET_QUESTIONS_FAILURE]: (state, payload) => {
    state.questionsLoading = false;
    state.questionsLoadSuccess = false;
    state.questionsLoadError = payload;
    state.questionList = [];
    state.questionsPage = 0;
    state.questionsTotalPages = 0;
  },

  [types.APPEND_QUESTIONS_REQUEST]: state => {
    state.questionsLoading = true;
    state.questionsLoadSuccess = false;
    state.questionsLoadError = null;
  },
  [types.APPEND_QUESTIONS_SUCCESS]: (state, payload) => {
    state.questionsLoading = false;
    state.questionsLoadSuccess = true;
    state.questionList = [...state.questionList, ...payload.entries];
    state.questionsPage =
      payload.pageNumber > state.questionsPage ? payload.pageNumber : state.questionsPage;
    state.questionsTotalPages = payload.totalPages;
  },
  [types.APPEND_QUESTIONS_FAILURE]: (state, payload) => {
    state.questionsLoading = false;
    state.questionsLoadSuccess = false;
    state.questionsLoadError = payload;
  },

  [types.CREATE_QUESTION_REQUEST]: state => {
    state.questionsSaving = true;
    state.questionsSaveSuccess = false;
    state.questionsSaveError = null;
  },
  [types.CREATE_QUESTION_SUCCESS]: (state, payload) => {
    state.questionsSaving = false;
    state.questionsSaveSuccess = true;
    state.questionList = [payload, ...state.questionList];
  },
  [types.CREATE_QUESTION_FAILURE]: (state, payload) => {
    state.questionsSaving = false;
    state.questionsSaveSuccess = false;
    state.questionsSaveError = payload;
  },

  [types.UPDATE_QUESTION_REQUEST]: state => {
    state.questionsSaving = true;
    state.questionsSaveSuccess = false;
    state.questionsSaveError = null;
  },
  [types.UPDATE_QUESTION_SUCCESS]: (state, payload) => {
    state.questionsSaving = false;
    state.questionsSaveSuccess = true;

    const updateQuestions = questionCollection =>
      questionCollection.map(question => {
        if (question.id === payload.id) {
          return applyQuestionLinkMetadata(payload);
        }
        return question;
      });

    state.questionList = updateQuestions(state.questionList);
    state.canvasQuestions = updateQuestions(state.canvasQuestions);
  },
  [types.UPDATE_QUESTION_FAILURE]: (state, payload) => {
    state.questionsSaving = false;
    state.questionsSaveSuccess = false;
    state.questionsSaveError = payload;
  },

  // CHOICES
  [types.GET_CHOICES_REQUEST]: state => {
    state.choicesLoading = true;
    state.choicesLoadSuccess = false;
    state.choicesLoadError = null;
  },
  [types.GET_CHOICES_SUCCESS]: (state, payload) => {
    state.choicesLoading = false;
    state.choicesLoadSuccess = true;
    state.choiceList = payload.entries;
    state.choicesPage = payload.pageNumber;
    state.choicesTotalPages = payload.totalPages;
  },
  [types.GET_CHOICES_FAILURE]: (state, payload) => {
    state.choicesLoading = false;
    state.choicesLoadSuccess = false;
    state.choicesLoadError = payload;
    state.choiceList = [];
    state.choicesPage = 0;
    state.choicesTotalPages = 0;
  },

  [types.APPEND_CHOICES_REQUEST]: state => {
    state.choicesLoading = true;
    state.choicesLoadSuccess = false;
    state.choicesLoadError = null;
  },
  [types.APPEND_CHOICES_SUCCESS]: (state, payload) => {
    state.choicesLoading = false;
    state.choicesLoadSuccess = true;
    state.choiceList = [...state.choiceList, ...payload.entries];
    state.choicesPage =
      payload.pageNumber > state.choicesPage ? payload.pageNumber : state.choicesPage;
    state.choicesTotalPages = payload.totalPages;
  },
  [types.APPEND_CHOICES_FAILURE]: (state, payload) => {
    state.choicesLoading = false;
    state.choicesLoadSuccess = false;
    state.choicesLoadError = payload;
  },

  // CHOICE TEMPLATES
  [types.GET_CHOICE_TEMPLATES_REQUEST]: state => {
    state.choiceTemplatesLoading = true;
    state.choiceTemplatesLoadSuccess = false;
    state.choiceTemplatesLoadError = null;
  },
  [types.GET_CHOICE_TEMPLATES_SUCCESS]: (state, payload) => {
    state.choiceTemplatesLoading = false;
    state.choiceTemplatesLoadSuccess = true;
    state.choiceTemplateList = payload.entries;
    state.choiceTemplatesPage = payload.pageNumber;
    state.choiceTemplatesTotalPages = payload.totalPages;
  },
  [types.GET_CHOICE_TEMPLATES_FAILURE]: (state, payload) => {
    state.choiceTemplatesLoading = false;
    state.choiceTemplatesLoadSuccess = false;
    state.choiceTemplatesLoadError = payload;
    state.choiceTemplateList = [];
    state.choiceTemplatesPage = 0;
    state.choiceTemplatesTotalPages = 0;
  },

  [types.APPEND_CHOICE_TEMPLATES_REQUEST]: state => {
    state.choiceTemplatesLoading = true;
    state.choiceTemplatesLoadSuccess = false;
    state.choiceTemplatesLoadError = null;
  },
  [types.APPEND_CHOICE_TEMPLATES_SUCCESS]: (state, payload) => {
    state.choiceTemplatesLoading = false;
    state.choiceTemplatesLoadSuccess = true;
    state.choiceTemplateList = [...state.choiceTemplateList, ...payload.entries];
    state.choiceTemplatesPage =
      payload.pageNumber > state.choiceTemplatesPage
        ? payload.pageNumber
        : state.choiceTemplatesPage;
    state.choiceTemplatesTotalPages = payload.totalPages;
  },
  [types.APPEND_CHOICE_TEMPLATES_FAILURE]: (state, payload) => {
    state.choiceTemplatesLoading = false;
    state.choiceTemplatesLoadSuccess = false;
    state.choiceTemplatesLoadError = payload;
  },

  [types.CREATE_CHOICE_TEMPLATE_REQUEST]: state => {
    state.choiceTemplateSaving = true;
    state.choiceTemplateSaveSuccess = false;
    state.choiceTemplateSaveError = null;
  },
  [types.CREATE_CHOICE_TEMPLATE_SUCCESS]: (state, payload) => {
    state.choiceTemplatesSaving = false;
    state.choiceTemplatesSaveSuccess = true;
    state.choiceTemplateList = [...state.choiceTemplateList, payload];
  },
  [types.CREATE_CHOICE_TEMPLATE_FAILURE]: (state, payload) => {
    state.choiceTemplatesSaving = false;
    state.choiceTemplatesSaveSuccess = false;
    state.choiceTemplatesSaveError = payload;
  },

  [types.UPDATE_CHOICE_TEMPLATE_REQUEST]: state => {
    state.choiceTemplateSaving = true;
    state.choiceTemplateSaveSuccess = false;
    state.choiceTemplateSaveError = null;
  },
  [types.UPDATE_CHOICE_TEMPLATE_SUCCESS]: (state, payload) => {
    state.choiceTemplatesSaving = false;
    state.choiceTemplatesSaveSuccess = true;
    state.choiceTemplateList = state.choiceTemplateList.map(template => {
      if (template.id === payload.id) {
        return payload;
      }
      return template;
    });
  },
  [types.UPDATE_CHOICE_TEMPLATE_FAILURE]: (state, payload) => {
    state.choiceTemplatesSaving = false;
    state.choiceTemplatesSaveSuccess = false;
    state.choiceTemplatesSaveError = payload;
  },

  // QUESTION CATEGOREIS
  [types.GET_QUESTION_CATEGORIES_REQUEST]: state => {
    state.questionCategoriesLoading = true;
    state.questionCategoriesLoadSuccess = false;
    state.questionCategoriesLoadError = null;
  },
  [types.GET_QUESTION_CATEGORIES_SUCCESS]: (state, payload) => {
    state.questionCategoriesLoading = false;
    state.questionCategoriesLoadSuccess = true;
    state.questionCategoryList = payload;
  },
  [types.GET_QUESTION_CATEGORIES_FAILURE]: (state, payload) => {
    state.questionCategoriesLoading = false;
    state.questionCategoriesLoadSuccess = false;
    state.questionCategoriesLoadError = payload;
    state.questionCategoryList = [];
  },

  [types.GET_QUESTION_CATEGORIES_WITH_QUESTIONS_REQUEST]: state => {
    state.questionCategoriesWithQuestionsLoading = true;
    state.questionCategoriesWithQuestionsLoadSuccess = false;
    state.questionCategoriesWithQuestionsLoadError = null;
  },
  [types.GET_QUESTION_CATEGORIES_WITH_QUESTIONS_SUCCESS]: (state, payload) => {
    state.questionCategoriesWithQuestionsLoading = false;
    state.questionCategoriesWithQuestionsLoadSuccess = true;
    state.questionCategoryWithQuestionsList = payload;
  },
  [types.GET_QUESTION_CATEGORIES_WITH_QUESTIONS_FAILURE]: (state, payload) => {
    state.questionCategoriesWithQuestionsLoading = false;
    state.questionCategoriesWithQuestionsLoadSuccess = false;
    state.questionCategoriesWithQuestionsLoadError = payload;
    state.questionCategoryWithQuestionsList = [];
  },

  [types.CREATE_QUESTION_CATEGORY_REQUEST]: state => {
    state.questionCategoriesCreating = true;
    state.questionCategoriesCreateSuccess = false;
    state.questionCategoriesCreateError = null;
  },
  [types.CREATE_QUESTION_CATEGORY_SUCCESS]: (state, payload) => {
    state.questionCategoriesCreating = false;
    state.questionCategoriesCreateSuccess = true;
    state.questionCategoryList = [...state.questionCategoryList, payload].sort((a, b) =>
      a.title.localeCompare(b.title),
    );
  },
  [types.CREATE_QUESTION_CATEGORY_FAILURE]: (state, payload) => {
    state.questionCategoriesCreating = false;
    state.questionCategoriesCreateSuccess = false;
    state.questionCategoriesCreateError = payload;
  },

  // GET CHOICE CATEGORIES
  [types.GET_CHOICE_CATEGORIES_REQUEST]: state => {
    state.choiceCategoriesLoading = true;
    state.choiceCategoriesLoadSuccess = false;
    state.choiceCategoriesLoadError = null;
  },
  [types.GET_CHOICE_CATEGORIES_SUCCESS]: (state, payload) => {
    state.choiceCategoriesLoading = false;
    state.choiceCategoriesLoadSuccess = true;
    state.choiceCategoryList = payload;
  },
  [types.GET_CHOICE_CATEGORIES_FAILURE]: (state, payload) => {
    state.choiceCategoriesLoading = false;
    state.choiceCategoriesLoadSuccess = false;
    state.choiceCategoriesLoadError = payload;
    state.choiceCategoryList = [];
  },

  [types.CREATE_CHOICE_CATEGORY_REQUEST]: state => {
    state.choiceCategoriesCreating = true;
    state.choiceCategoriesCreateSuccess = false;
    state.choiceCategoriesCreateError = null;
  },
  [types.CREATE_CHOICE_CATEGORY_SUCCESS]: (state, payload) => {
    state.choiceCategoriesCreating = false;
    state.choiceCategoriesCreateSuccess = true;
    state.choiceCategoryList = [...state.choiceCategoryList, payload].sort((a, b) =>
      a.title.localeCompare(b.title),
    );
  },
  [types.CREATE_CHOICE_CATEGORY_FAILURE]: (state, payload) => {
    state.choiceCategoriesCreating = false;
    state.choiceCategoriesCreateSuccess = false;
    state.choiceCategoriesCreateError = payload;
  },

  // CREATE SURVEY
  [types.CREATE_SURVEY_REQUEST]: state => {
    state.survey = null;
    state.surveySaving = true;
    state.surveySaveSuccess = false;
    state.surveySaveError = null;
  },
  [types.CREATE_SURVEY_SUCCESS]: (state, payload) => {
    state.survey = payload.data.surveysCreate;
    state.surveySaving = false;
    state.surveySaveSuccess = true;

    state.canvasQuestions = transformSurveyQuestions([]);
  },
  [types.CREATE_SURVEY_FAILURE]: (state, payload) => {
    state.survey = null;
    state.surveySaving = false;
    state.surveySaveSuccess = false;
    state.surveySaveError = payload;
  },

  [types.UPDATE_SURVEY_REQUEST]: state => {
    state.surveySaving = true;
    state.surveySaveSuccess = false;
    state.surveySaveError = null;
  },
  [types.UPDATE_SURVEY_SUCCESS]: (state, payload) => {
    state.survey = payload.data.surveysUpdate;
    state.surveySaving = false;
    state.surveySaveSuccess = true;

    state.canvasQuestions = transformSurveyQuestions(state.survey.questions);
  },
  [types.UPDATE_SURVEY_FAILURE]: (state, payload) => {
    state.surveySaving = false;
    state.surveySaveSuccess = false;
    state.surveySaveError = payload;
  },

  [types.UPDATE_CANVAS_QUESTIONS_REQUEST]: state => {
    state.canvasQuestionsUpdating = true;
    state.canvasQuestionsUpdateSuccess = false;
    state.canvasQuestionsUpdateError = null;
  },
  [types.UPDATE_CANVAS_QUESTIONS_SUCCESS]: (state, payload) => {
    state.canvasQuestionsUpdating = false;
    state.canvasQuestionsUpdateSuccess = true;

    state.canvasQuestions = transformSurveyQuestions(payload.questions);
  },
  [types.UPDATE_CANVAS_QUESTIONS_FAILURE]: (state, payload) => {
    state.canvasQuestionsUpdating = false;
    state.canvasQuestionsUpdateSuccess = false;
    state.canvasQuestionsUpdateError = payload;
  },

  // HOOKS
  [types.GET_HOOKS_REQUEST]: state => {
    state.hooksLoading = true;
    state.hooksLoadSuccess = false;
    state.hooksLoadError = null;
  },
  [types.GET_HOOKS_SUCCESS]: (state, payload) => {
    state.hooksLoading = false;
    state.hooksLoadSuccess = true;
    state.hookList = payload.entries;
    state.hooksPage = payload.pageNumber;
    state.hooksTotalPages = payload.totalPages;
  },
  [types.GET_HOOKS_FAILURE]: (state, payload) => {
    state.hooksLoading = false;
    state.hooksLoadSuccess = false;
    state.hooksLoadError = payload;
    state.hookList = [];
    state.hooksPage = 0;
    state.hooksTotalPages = 0;
  },

  [types.CREATE_HOOK_REQUEST]: state => {
    state.hooksCreating = true;
    state.hooksCreateSuccess = false;
    state.hooksCreateError = null;
  },
  [types.CREATE_HOOK_SUCCESS]: (state, payload) => {
    state.hooksCreating = false;
    state.hooksCreateSuccess = true;
    state.hookList = [...state.hookList, payload];
  },
  [types.CREATE_HOOK_FAILURE]: (state, payload) => {
    state.hooksCreating = false;
    state.hooksCreateSuccess = false;
    state.hooksCreateError = payload;
  },

  [types.UPDATE_HOOK_REQUEST]: state => {
    state.hooksSaving = true;
    state.hooksSaveSuccess = false;
    state.hooksSaveError = null;
  },
  [types.UPDATE_HOOK_SUCCESS]: (state, payload) => {
    state.hooksSaving = false;
    state.hooksSaveSuccess = true;
    state.hookList = state.hookList.map(hook => {
      if (hook.id === payload.id) {
        return payload;
      }
      return hook;
    });
  },
  [types.UPDATE_HOOK_FAILURE]: (state, payload) => {
    state.hooksSaving = false;
    state.hooksSaveSuccess = false;
    state.hooksSaveError = payload;
  },

  [types.APPEND_HOOKS_REQUEST]: state => {
    state.hooksLoading = true;
    state.hooksLoadSuccess = false;
    state.hooksLoadError = null;
  },
  [types.APPEND_HOOKS_SUCCESS]: (state, payload) => {
    state.hooksLoading = false;
    state.hooksLoadSuccess = true;
    state.hookList = [...state.hookList, ...payload.entries];
    state.hooksPage = payload.pageNumber > state.hookssPage ? payload.pageNumber : state.hooksPage;
    state.hooksTotalPages = payload.totalPages;
  },
  [types.APPEND_HOOKS_FAILURE]: (state, payload) => {
    state.hooksLoading = false;
    state.hooksLoadSuccess = false;
    state.hooksLoadError = payload;
  },

  // MATRIX CHOICES (MUSIC QUESTIONS)
  [types.GET_MATRIX_CHOICES_REQUEST]: state => {
    state.matrixChoicesLoading = true;
    state.matrixChoicesLoadSuccess = false;
    state.matrixChoicesLoadError = null;
  },
  [types.GET_MATRIX_CHOICES_SUCCESS]: (state, payload) => {
    state.matrixChoicesLoading = false;
    state.matrixChoicesLoadSuccess = true;
    state.matrixChoiceList = payload.entries;
    state.matrixChoicesPage = payload.pageNumber;
    state.matrixChoicesTotalPages = payload.totalPages;
  },
  [types.GET_MATRIX_CHOICES_FAILURE]: (state, payload) => {
    state.matrixChoicesLoading = false;
    state.matrixChoicesLoadSuccess = false;
    state.matrixChoicesLoadError = payload;
    state.matrixChoiceList = [];
    state.matrixChoicesPage = 0;
    state.matrixChoicesTotalPages = 0;
  },

  [types.UPDATE_MATRIX_CHOICE_REQUEST]: state => {
    state.matrixChoicesSaving = true;
    state.matrixChoicesSaveSuccess = false;
    state.matrixChoicesSaveError = null;
  },
  [types.UPDATE_MATRIX_CHOICE_SUCCESS]: (state, payload) => {
    state.matrixChoicesSaving = false;
    state.matrixChoicesSaveSuccess = true;
    state.matrixChoiceList = state.matrixChoiceList.map(matrixChoice => {
      if (matrixChoice.id === payload.id) {
        return payload;
      }
      return matrixChoice;
    });
  },
  [types.UPDATE_MATRIX_CHOICE_FAILURE]: (state, payload) => {
    state.matrixChoicesSaving = false;
    state.matrixChoicesSaveSuccess = false;
    state.matrixChoicesSaveError = payload;
  },

  [types.APPEND_MATRIX_CHOICES_REQUEST]: state => {
    state.matrixChoicesLoading = true;
    state.matrixChoicesLoadSuccess = false;
    state.matrixChoicesLoadError = null;
  },
  [types.APPEND_MATRIX_CHOICES_SUCCESS]: (state, payload) => {
    state.matrixChoicesLoading = false;
    state.matrixChoicesLoadSuccess = true;
    state.matrixChoiceList = [...state.matrixChoiceList, ...payload.entries];
    state.matrixChoicesPage =
      payload.pageNumber > state.matrixChoicesPage ? payload.pageNumber : state.matrixChoicesPage;
    state.matrixChoicesTotalPages = payload.totalPages;
  },
  [types.APPEND_MATRIX_CHOICES_FAILURE]: (state, payload) => {
    state.matrixChoicesLoading = false;
    state.matrixChoicesLoadSuccess = false;
    state.matrixChoicesLoadError = payload;
  },

  [types.CREATE_MATRIX_CHOICE_REQUEST]: state => {
    state.matrixChoicesCreating = true;
    state.matrixChoicesCreateSuccess = false;
    state.matrixChoicesCreateError = null;
  },
  [types.CREATE_MATRIX_CHOICE_SUCCESS]: (state, payload) => {
    state.matrixChoicesCreating = false;
    state.matrixChoicesCreateSuccess = true;
    state.matrixChoiceList = [...state.matrixChoiceList, payload];
  },
  [types.CREATE_MATRIX_CHOICE_FAILURE]: (state, payload) => {
    state.matrixChoicesCreating = false;
    state.matrixChoicesCreateSuccess = false;
    state.matrixChoicesCreateError = payload;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/surveybuilder/api-mutations.js